module.exports = __webpack_public_path__ + "static/media/01.4f110484.mp3";